import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, { Dispatch, FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { ItineraryStatus } from '../../models/itinerary';
import { AppState } from '../../store/model';
import { setRecommandedCombination } from '../../store/reducers/itinerary/actions';
import { getStatus } from '../../store/reducers/itinerary/selectors';
import Button from '@material-ui/core/Button'

interface OwnProps {
  isSelected?: boolean;
  combinationIndex: number;
  isLastFlight?: boolean;
}

interface StateProps {
  status?: ItineraryStatus;
}

interface DispatchProps {
  setSelected(selectedIndex: number): void;
}

const styles = (theme: Theme) => {
  return createStyles({
    mainWarp: {
      width: '233px',
      height: '86px',
      paddingLeft: 28,
      paddingRight: 28,
      paddingTop: theme.spacing.unit * 3,
      paddingBottom: theme.spacing.unit * 3,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-end',
      display: 'inline-flex',
      boxSizing: 'border-box',
      borderLeft: '1px #E0E0E0 solid',
      borderTop: '1px #E0E0E0 solid',
      borderBottom: '1px #E0E0E0 solid',
      backgroundColor: 'white',
    },
    backgroundColorSelected: { backgroundColor: '#F5F5F5' },
    borderRight: { borderRight: '1px solid #E0E0E0' },
    selectStyle: {
      alignSelf: 'stretch',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      borderRadius: 2,
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'inline-flex',
    },
    noSelectStyle: {
      alignSelf: 'stretch',
      height: 40,
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      background: '#00DE00',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.16)',
      borderRadius: 2,
      overflow: 'hidden',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
    },
    buttonWarp: {
      ustifyContent: 'center',
      alignItems: 'center',
      gap: 8,
      display: 'flex',
    },
    buttonText: {
      fontSize: 14,
      fontFamily: 'Roboto Medium',
      fontWeight: 500,
      textTransform: 'uppercase',
      lineHeight: 24,
      letterSpacing: 0.4,
      wordWrap: 'break-word',
    },
    selectButtonText: {
      color: theme.zeno.main.primary.main,
    },
  });
};
interface SelectButtonProps
  extends OwnProps,
  StateProps,
  DispatchProps,
  WithStyles<typeof styles>,
  InjectedIntlProps { }

const _SelectButtonBase: FunctionComponent<SelectButtonProps> = ({
  isSelected,
  classes,
  setSelected,
  combinationIndex,
  isLastFlight,
}) => {
  const selectedText = isSelected ? 'selectED' : 'select';

  return (
    <Grid
      className={classNames(classes.mainWarp, {
        [classes.backgroundColorSelected]: isSelected,
        [classes.borderRight]: isLastFlight,
      })}
    >
      {
        isSelected ? (
          <Grid
            className={classNames({
              [classes.selectStyle]: isSelected,
            })}
            onClick={() => setSelected(combinationIndex)}
          >
            <Grid className={classes.buttonWarp}>
              <Typography
                className={classNames(classes.buttonText, {
                  [classes.selectButtonText]: isSelected,
                })}
              >
                {selectedText}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setSelected(combinationIndex)}
            fullWidth
          >
            {selectedText}
          </Button>
        )
      }
    </Grid>
  );
};



const mapStateToProps = (state: AppState): StateProps => {
  return {
    status: getStatus(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  setSelected: (selectedIndex: number) => {
    dispatch(
      setRecommandedCombination({
        name: 'selectedAirCombinationIndex',
        index: selectedIndex,
      }),
    );
  },
});

const enhance = compose<SelectButtonProps, OwnProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  injectIntl,
);

export const SelectButton = enhance(_SelectButtonBase);

SelectButton.displayName = 'SelectButtonBase';
